import React from "react";

export default function WorkspaceOverviewSkeleton() {
  return (
    <div className="rr-overview" aria-busy="true">
      <p className="rr-sr">Loading workspace</p>
      <div className="rr-overview-head">
        <span className="rr-skel rr-skel-eyebrow" />
        <span className="rr-skel rr-skel-title" />
        <span className="rr-skel rr-skel-sub" />
      </div>
      <div className="rr-skel rr-skel-status" />
      <div className="rr-skel rr-skel-pipeline" />
      <div className="rr-overview-split">
        <div className="rr-skel rr-skel-card" />
        <div className="rr-skel rr-skel-card" />
      </div>
      <div className="rr-skel rr-skel-table" />
    </div>
  );
}
